import React from 'react';

const WorkflowContext = React.createContext({
  workflow: null,
  refreshWorkflow: () => {},
});

export default WorkflowContext;
